// extracted by mini-css-extract-plugin
module.exports = {"container":"_2r4WgqYa9OEKTCUSOMtnl","icon":"_1QQpchsQE9JNvtqBPG4FZZ"};